import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { parseDate, toTextualDateString } from '@/date';
import { toCurrencyString } from '@/number';
import { pluralize } from '@/utils';

const propTypes = {
  periodicity: PropTypes.oneOf(['monthly', 'quarterly', 'half_yearly', 'yearly']).isRequired,
  finalValue: PropTypes.number.isRequired,
  completeFinalValue: PropTypes.number.isRequired,
  expirationDate: PropTypes.string.isRequired,
  maxUsersCount: PropTypes.number,
  addonsInfo: PropTypes.arrayOf(PropTypes.shape({
    productCode: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  }))
};

const periodicityText = {
  monthly: 'mensal',
  quarterly: 'trimestral',
  half_yearly: 'semestral',
  yearly: 'anual'
};

function CurrentPlanPaymentSummary({
  periodicity,
  finalValue,
  completeFinalValue,
  expirationDate,
  maxUsersCount,
  addonsInfo
}) {
  const expirationDateFormatted = toTextualDateString(parseDate(expirationDate));
  const finalValueFormatted = toCurrencyString(finalValue);
  const completeFinalValueFormatted = toCurrencyString(completeFinalValue);

  return (
    <div
      id='payment-summary'
      className={
        classnames(
          'w-100',
          'text-small',
          'bg-light'
        )
      }
    >
      <h4 className='mt-2 mb-4'>Resumo</h4>

      <RowContent
        title={`Assinatura ${periodicityText[periodicity]}`}
        content={`Até ${expirationDateFormatted}`}
      />

      <RowContent
        title={`${maxUsersCount} ${pluralize('usuário', maxUsersCount)}`}
        content={finalValueFormatted}
      />

      {addonsInfo.map((addon) => (
        <RowContent
          key={addon.productCode}
          title={getAddonTitle(addon)}
          content={toCurrencyString(addon.value)}
        />
      ))}

      <hr className='mt-3 mb-2 opacity-100' />

      <div className='mt-5 d-flex align-items-baseline justify-content-between mb-1'>
        <h4 className='text-dark-gray me-5'>Valor da assinatura {periodicityText[periodicity]}</h4>

        <h5>{completeFinalValueFormatted}</h5>
      </div>
    </div>
  );
}

function RowContent({ title, content }) {
  return (
    <div className='d-flex align-items-baseline justify-content-between mb-1'>
      <div className='fw-bold text-dark-gray me-8'>{title}</div>

      <div className='ms-2'>{content}</div>
    </div>
  );
}

function getAddonTitle(addon) {
  if (addon.productCode === 'whatsapp_number') {
    return `
      ${addon.quantity} ${pluralize('número', addon.quantity)}
      ${pluralize('extra', addon.quantity)} do WhatsApp
    `;
  }
}

CurrentPlanPaymentSummary.propTypes = propTypes;

export default CurrentPlanPaymentSummary;
